/*
 * Copyright (c) 2023 Potentially Ltd
 *
 * Please see distribution for license
 */

import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { GoalCardDetail } from '../../../../../shared/models';
import { SetPlaylistGoalCards } from './playlist-goals.actions';
import { INITIAL_STATE, PlaylistResourceEditorGoalsStateModel } from './playlist-goals.state.model';

@State<PlaylistResourceEditorGoalsStateModel>({
  name: 'PlaylistGoals',
  defaults: INITIAL_STATE,
})
@Injectable()
export class PlaylistResourceEditorGoalsState {
  // -----------------------------------------------------------------------------------------------------
  // @ Selectors
  // -----------------------------------------------------------------------------------------------------
  @Selector()
  static goalCards({ goalCards }: PlaylistResourceEditorGoalsStateModel): GoalCardDetail[] {
    return goalCards || [];
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Actions
  // -----------------------------------------------------------------------------------------------------
  @Action(SetPlaylistGoalCards)
  setPlaylistGoalCards({ patchState }: StateContext<PlaylistResourceEditorGoalsStateModel>, { goalCards }: SetPlaylistGoalCards) {
    patchState({
      goalCards: goalCards,
    });
  }
}
